import Style from './style'

const SupabaseConnectError = ({isVisible = false, status = ''}) => {
	if (!isVisible) {
		return null
	}

	return (
		<Style.Container>
			<Style.Icon>🚫</Style.Icon>
			<Style.Message>
				Supabase real-time connection failed {status}, trying to reconnect...
			</Style.Message>
		</Style.Container>
	)
}

export default SupabaseConnectError
